<template>
  <div
    id="footer-bar"
    class=" z-10 w-full bg-transparent flex flex-col text-center items-center sm:items-start  relative p-1"
  >
    <h5 class="text-light leading-none m-1">
      Copyright © {{ dateYear }} Advanced Prototype Engineering

      <a
        class="underline"
        href="https://aproe.com/privacy-policy/"
        rel="noopener noreferrer"
        target="_blank"
      >Privacy Policy</a>

      |

      <a
        class="underline"
        href="https://aproe.com/terms-conditions/"
        rel="noopener noreferrer"
        target="_blank"
      >Terms & Conditions</a>
    </h5>
    <h5 class="text-light leading-none m-1">
      Run into problems?
      <a
        class="underline"
        href="https://aproe.com/contact/"
        rel="noopener noreferrer"
        target="_blank"
      >Let us know</a>
      and help us improve!
    </h5>
  </div>
</template>
<script>
export default {
  name: 'FooterBar',
  data () {
    return {
      dateYear: new Date().getFullYear(),
    }
  },
  computed: {},
  methods: {},
}
</script>

<style lang="postcss" scoped>
h5 {
  font-size: 11px;
}

h5 a:hover {
  color: rgba(255, 255, 255, 0.5);
}
</style>
